<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col">
        <h4><i class="fa fa-trophy"></i><span class="ml-1">Recharges</span></h4>
      </div>
      <div class="col">
        <div class="float-right">
          <h5><i class="fa fa-credit-card"></i> Wallet Balance : <b>{{ balance }}</b></h5>
        </div>
      </div>
    </div>
    <div class="card">
      <v-client-table :data="recharges" :columns="columns" :options="options">
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="`/users/show/${props.row.id}`">
              <span
                class="btn btn-primary btn-sm m-1"
                data-toggle="tooltip"
                data-placement="top"
                title="View"
              >
                <CIcon name="cil-magnifying-glass" size="sm" />
              </span>
            </router-link>
          </div>
        </template>
      </v-client-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import paginate from "vuejs-paginate";
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

export default {
  name: "Recharges",
  data() {
    return {
      recharges: [],
      balance: "",
      columns: ["id", "name", "phone", "amount", "created_at", "action"],
      date: new Date(),
      type: "",
      options: {
        pagination: { nav: "fixed" },
        filterByColumn: true,
        dateColumns: ["created_at"],
        //dateFormat: 'DD-MM-YYYY',
        toMomentFormat: true,
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    };
  },
  created() {
    this.getRecharges();
    this.getBalance();
  },
  methods: {
    recharge(id) {
      this.$swal({
        title: "Are you sure?",
        type: "warning",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      })
        .then((result) => {
          if (result.value) {
            this.confirmRecharge(id);
          }
        })
        .catch((error) => {
          //console.log('Sweetalert ERROR');
        });
    },
    confirmRecharge(id) {
      const user_id = id;
      axios
        .post(`${ADMIN_URL}/recharge`, {
          user_id: user_id,
        })
        .then((response) => {
          console.log("res", response);
          console.log("data", response.data.error_code);
          console.log("description", response.data.description);

          if (response.data.error_code === "109") {
            this.$swal("Success", response.data.description, "success");
          } else {
            this.$swal("Error", response.data.description, "error");
          }
        })
        .catch((error) => {
          this.$swal("Error", error.response.data.description, "error");
        });
    },
    getRecharges() {
      axios
        .get(`${ADMIN_URL}/recharges`)
        .then((response) => {
          this.recharges = response.data.map((x) => {
            const obj = {};
            obj.id = x.id;
            obj.name = x.user.name;
            obj.phone = x.user.phone;
            obj.amount = x.amount;
            obj.sent_by = x.sent_by;
            obj.created_at = moment(x.created_at).format(
              "DD/MM/YYYY, h:mm:ss a"
            );
            return obj;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getBalance() {
      axios
        .get(`${ADMIN_URL}/balance`)
        .then((response) => {
          this.balance = response.data.balance;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
</style>
